import React from 'react'
import classnames from 'classnames'

/* eslint-disable react/prop-types */

export default function Label({ children, inline, style, ...labelProps }) {
    if (! children) {
        return null
    }

    const labelClasses = classnames({
        'form__label': true,
        'form__label--inline': inline,
    })

    return (
        <label { ...labelProps } className={ labelClasses } style={ style }>
            { children }
        </label>
    )
}



// WEBPACK FOOTER //
// ./app/components/ui/label.js